// extracted by mini-css-extract-plugin
module.exports = {"form":"Modal_form__28uFp","input":"Modal_input__27BRm","icon":"Modal_icon__1kq5Z","collapsePanel":"Modal_collapsePanel__nJXiQ"};